import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, TabsProps } from 'antd';

import { BeraStep } from './BeraStep';
import { useBeraJobStepsContext } from '../context';
import { useBeraReportStepsContext } from './context';
import { CustomTabs } from './styles';

export function BeraFormSteps() {
	const { handleTabClick } = useBeraReportStepsContext();
	const { currentActiveTabIndex } = useBeraReportStepsContext();
	const { selectedFiles, showBeraJobResult, tabsDisabled } = useBeraJobStepsContext();

	const items: TabsProps['items'] = selectedFiles.map((file, index) => {
		const key = String(index + 1);
		return {
			key,
			label: `${I18n.get('Task')} ${key}`,
			children: currentActiveTabIndex === key && <BeraStep key={file.id} file={file} />
		};
	});

	return (
		<Row justify="center">
			<Col xs={24}>
				<CustomTabs
					showberajobresult={String(showBeraJobResult)}
					onChange={handleTabClick}
					tabPosition="left"
					activeKey={currentActiveTabIndex}
					items={items}
					last={items.length}
					disabled={tabsDisabled}
				/>
			</Col>
		</Row>
	);
}
